// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"957492bc","686":"be4b2b97","740":"42966ba9","843":"62ae7e60"}[chunkId] + ".chunk.js";
};